import TrackingHelper from "helpers/TrackingHelpers";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store/hooks"
import EntryFormatter from "utils/EntryFormatter";

export const useChameleonIdentify = () => {
   const {data: user, isSuccess}  = useAppSelector(state => state.user);
   const location = useLocation()
   const lastIdentifiedUser = useRef<string | null>(null);
   
   useEffect(() => {
      // Only executes if user exists and is not empty
      if (!EntryFormatter.isObjectEmpty(user) && user.userId) {
         // Checks if we already identified this user to avoid duplicate calls
         if (lastIdentifiedUser.current === user.userId) {
            return;
         }
         
         // Function to store the UTM parameters in a cookie
         TrackingHelper.storeUTMparams()
         
         window.analytics.identify(user.userId, {
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            company: EntryFormatter.exists(user.organization) ? user.organization?.name : user.organizationName,
            companyId: EntryFormatter.exists(user.organization) ? user.organization?.id : null,
            creditBalance: user.creditBalance,
            creditPurchase: user.creditPurchase || 0,
            creditUsage: user.creditUsage || 0,
            revenue: user?.revenue || 0,
            campaign: TrackingHelper.getUtmMetrics()
         }
            // , { integrations: { "All": false, "Chameleon": true, "Salesforce" : true}}
         )
         
         // Marks this user as already identified
         lastIdentifiedUser.current = user.userId;
      }
   }, [user, isSuccess]) // Removed location.pathname from dependencies

}